import { PERMISSION_MATRIX } from "@/lib/rbac";
import { Check, X } from "lucide-react";

export default function RolePermissions() {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="font-display text-base font-semibold text-slate-900 mb-3">Role Permissions</h3>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-slate-400 border-b border-slate-100">
            <th className="text-left py-2 font-semibold">Capability</th>
            <th className="py-2 font-semibold">Adm</th>
            <th className="py-2 font-semibold">Plan</th>
            <th className="py-2 font-semibold">Ops</th>
          </tr>
        </thead>
        <tbody>
          {PERMISSION_MATRIX.map((p) => (
            <tr key={p.feature} className="border-b border-slate-50">
              <td className="py-2 text-slate-600">{p.feature}</td>
              {["admin", "planner", "operator"].map((r) => (
                <td key={r} className="py-2 text-center">
                  {p[r] ? <Check className="h-3.5 w-3.5 text-emerald-600 inline" /> : <X className="h-3.5 w-3.5 text-slate-300 inline" />}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
